module.exports = __webpack_public_path__ + "img/inter2.2320495d.jpg";